import Form from 'evcharging/components/Form';
import InputError from 'evcharging/components/InputError';
import Button from 'evcharging/components/Button';
import useInput from 'evcharging/hooks/useInput';
import { oneWord, trim } from 'evcharging/app/validation/filters';
import ResponsePopup from 'evcharging/components/ResponsePopup';
import Input from 'evcharging/components/Input';
import useFormResponse from 'evcharging/hooks/useFormResponse';
import Loader from 'evcharging/components/Loader';
import Textarea from 'evcharging/components/Textarea';
import Responsible from 'evcharging/components/Responsible';
import Spacer from 'evcharging/components/Spacer';
import sendRetailInquire from 'client/sendRetailInquire';
import { FC } from 'react';
import useI18n from 'evcharging/hooks/useI18n';

interface RatesConsultationForm {
  onDone?: () => void;
  zipCode: string;
  utilityName: string;
  customerType: string;
}

const RatesConsultationForm: FC<RatesConsultationForm> = (props) => {
  const { onDone, children, ...rest } = props;
  const { t } = useI18n();
  const fullName = useInput([trim]);
  const phone = useInput([trim]);
  const email = useInput([oneWord]);
  const message = useInput([trim]);

  const { isLoading, onSubmit, ...popup } = useFormResponse(
    { fullName, email, phone, message },
    async (values: Record<string, string>) => {
      await sendRetailInquire({ ...values, ...rest });
      if (onDone) {
        setTimeout(() => {
          onDone();
        }, 2000);
      }
    },
  );

  return (
    <Form onSubmit={onSubmit}>
      <ResponsePopup {...popup} />
      <Input
        required
        label={t('form.label.fullName')}
        placeholder={t('form.label.fullName-placeholder')}
        name={'fullName'}
        onChangeValue={fullName.onChangeValue}
        value={fullName.value}
        onBlur={() => {
          fullName.setError('');
        }}
        invalid={!!fullName.error}
      >
        <InputError message={fullName.error} />
      </Input>
      <Responsible fractions={[48, 48]} space={0}>
        <Input
          required
          label={t('form.label.email')}
          placeholder={t('form.placeholder.email')}
          name={'email'}
          onChangeValue={email.onChangeValue}
          value={email.value}
          onBlur={() => {
            email.setError('');
          }}
          invalid={!!email.error}
        >
          <InputError message={email.error} />
        </Input>
        <Input
          required
          label={t('form.label.phone')}
          placeholder={t('form.placeholder.phone')}
          type={'number'}
          name={'phone'}
          onChangeValue={phone.onChangeValue}
          onBlur={() => {
            phone.setError('');
          }}
          value={phone.value}
          invalid={!!phone.error}
        >
          <InputError message={phone.error} />
        </Input>
      </Responsible>
      <Textarea
        label={t('form.label.message')}
        placeholder={t('form.label.message-placeholder')}
        name={'message'}
        onChangeValue={message.onChangeValue}
        onBlur={() => {
          message.setError('');
        }}
        value={message.value}
      />
      <Spacer value={24} />
      <Button type="submit" disabled={isLoading} fullWidth>
        {isLoading ? <Loader /> : t('action.submit')}
      </Button>
    </Form>
  );
};

export default RatesConsultationForm;
